import { render } from "./command24Icon.vue?vue&type=template&id=fd29b79c&scoped=true"
const script = {}

import "./command24Icon.vue?vue&type=style&index=0&id=fd29b79c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd29b79c"]])

export default __exports__